import zhcn from "./i18nLangs/login/zh-cn";
import tw from "./i18nLangs/login/zh-tw";
import en from "./i18nLangs/login/en-us";
import ja from "./i18nLangs/login/ja-jp";
import kr from "./i18nLangs/login/ko-kr";
import es from "./i18nLangs/login/es-es";
import fr from "./i18nLangs/login/fr-fr";
import de from "./i18nLangs/login/de-de";

export const LANG_MAPS = [
  {
    text: "English",
    value: "en-us",
    img: require('@images/lang-en.png'),
    active: require('@images/lang-en-active.png'),
  },
  {
    text: "中文（繁體）",
    value: "zh-tw",
    img: require('@images/lang-zh.png'),
    active: require('@images/lang-zh-active.png'),
  },
  {
    text: "日本語",
    value: "ja-jp",
    img: require('@images/lang-jp.png'),
    active: require('@images/lang-jp-active.png'),
  },
  {
    text: "한국어",
    value: "ko-kr",
    img: require('@images/lang-kr.png'),
    active: require('@images/lang-kr-active.png'),
  },
  // {
  //   text: "Français",
  //   value: "fr-fr",
  // },
  // {
  //   text: "Deutsch",
  //   value: "de-de",
  // },

  // {
  //   text: "Español",
  //   value: "es-es",
  // },
];

export default {
  "zh-cn": zhcn,
  "zh-tw": tw,
  "en-us": en,
  "ja-jp": ja,
  "ko-kr": kr,
  "es-es": es,
  "fr-fr": fr,
  "de-de": de,
};
